import * as React from 'react';
import { RowModel } from '@tanstack/react-table';

import { NewTableDefaultDataItem } from '@common/components/new-table/new-table.types';
import { Row } from './components/row';
import { Waypoint } from 'react-waypoint';

export type BodyProps = {
  onRowContextMenu?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
  isRowSelected?: (item: NewTableDefaultDataItem) => boolean;
  itemUniqProperty: string;
  model: RowModel<NewTableDefaultDataItem>;
  onRowClick?: (params: { item: NewTableDefaultDataItem; e: React.MouseEvent<HTMLTableRowElement> }) => void;
  onLazyLoad?: () => void;
};

export const Body: React.FC<BodyProps> = (props) => {
  const { model, itemUniqProperty, onRowClick, isRowSelected, onRowContextMenu, onLazyLoad } = props;

  return (
    <tbody>
      {model.rows.map((row, index) => (
        <Row 
          index={index}
          key={row.original[itemUniqProperty]} 
          model={row} 
          selected={isRowSelected ? isRowSelected(row.original) : undefined}
          onClick={onRowClick} 
          onContextMenu={onRowContextMenu}
        />
      ))}
      {onLazyLoad && model.rows.length > 0 && (
        <Waypoint 
          topOffset={40}
          onEnter={onLazyLoad}
        />
      )}
    </tbody>
  );
};